import JSvsReact from './images/JSvReact.png'

const blog = [
    {
        id : 1,
        title : 'FETCH REQUESTS FOR BEGINNERS',
        date : 'JUNE 12, 2023',
        minutes: '3 MINUTE READ',
        preview: 'BEING ABLE TO COMMUNICATE WITH SERVERS IS A CRUCIAL ASPECT TO WEB DEVELOPMENT. AS DEVELOPERS, WE NEED TO BE ABLE TO RETRIEVE AND SUBMIT DATA, GET REAL TIME UPDATES, IMPLEMENT . . .',
        link : "https://dev.to/boucky/fetch-requests-for-beginners-35fn",
        image : 'https://res.cloudinary.com/practicaldev/image/fetch/s--yIzcbHBa--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/6vhs7whs1y597ks54a1x.jpg'
    },
    {
        id : 2,
        title : 'IMPOSTER SYNDROME IN THE TECH FIELD',
        date : 'JUNE 23, 2023',
        minutes: '4 MINUTE READ',
        preview: 'WHAT IS IMPOSTER SYNDROME? IMPOSTER SYNDROME REFERS TO A PSYCHOLOGICAL PHENOMENON WHERE INDIVIDUALS DOUBT THEIR ABILITIES AND ACCOMPLISHMENTS, FEELING LIKE THEY ARE UNDESERVING OF THEIR SUCCESS . . .',
        link : "https://dev.to/boucky/imposter-syndrome-in-the-tech-field-55ng",
        image : 'https://res.cloudinary.com/practicaldev/image/fetch/s--nAtWa0yu--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/nvshikyr9yvdr2ugmm11.jpeg'
    },
    {
        id : 3,
        title : 'JAVASCRIPT VS REACT',
        date : 'JUNE 25, 2023',
        minutes: '7 MINUTE READ',
        preview: 'WHAT IS REACT? YOU MAY HAVE HEARD OF REACT BEFORE, BUT WHAT EXACTLY IS IT? REACT IS AN OPEN-SOURCE JAVASCRIPT LIBRARY USED FOR BUILDING USER INTERFACES (UIS) IN WEB APPLICATIONS. IT WAS DEVELOPED BY FACEBOOK AND . . .',
        link : "https://dev.to/boucky/javascript-vs-react-23m0",
        image : JSvsReact
    },
    {
        id : 4,
        title : 'THESE SIMPLE CSS TRICKS WILL TAKE YOUR WEBSITE TO THE NEXT LEVEL',
        date : 'JULY 6, 2023',
        minutes: '5 MINUTE READ',
        preview: 'WHAT IS CSS? CSS, OR CASCADING STYLE SHEETS IS A FRONT-END LANGUAGE USED TO MAKE YOUR WEBSITE LOOK GOOD. WITHOUT CSS, YOUR WEBSITE WOULD . . .',
        link : "https://dev.to/boucky/these-simple-css-tricks-will-take-your-website-to-the-next-level-4neb",
        image : 'https://community-cdn-digitalocean-com.global.ssl.fastly.net/ghLpAM1gf6jm9AAqXekrZmip'
    },
    {
        id : 5,
        title : 'TOP-10 POST FOR FE (WEEK 1, JUL 2023)',
        date : 'JULY 10, 2023',
        minutes: '3 MINUTE READ',
        preview: "THIS IS A WONDERFUL BLOG WITH THE TOP 10 FRONT-END RELATED BLOGS FROM THE FIRST WEEK OF JULY, FEATURING MY PREVIOUS BLOG: 'THESE SIMPLE CSS TRICKS WILL TAKE YOUR WEBSITE TO THE NEXT LEVEL'! WRITTEN BY FRUNTEND.",
        link : "https://dev.to/fruntend/top-10-posts-for-fe-week-1-jul-2023-1931",
        image : 'https://res.cloudinary.com/practicaldev/image/fetch/s--yAMo7-TF--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/h52yd0jql2w19ehaq8vl.jpg'
    },
    {
        id : 6,
        title : 'PYTHON BEST PRACTICES: A GUIDE TO WRITING CLEAN AND READABLE CODE',
        date : 'JULY 14, 2023',
        minutes: '4 MINUTE READ',
        preview: 'THE ABILITY TO WRITE CLEAN AND READABLE CODE IS ESSENTIAL FOR NOT ONLY PYTHON DEVELOPERS, BUT ALL DEVELOPERS. HAVING CLEAN CODE . . .',
        link : "https://dev.to/boucky/python-best-practices-a-guide-to-writing-clean-and-readable-code-25k4",
        image : 'https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0349cd1nvtw9a2q39pde.png'
    },
    {
        id : 7,
        title : 'MASTERING THE LAUNCH: YOUR FULL-STACK APP DEPLOYMENT GUIDE WITH NETLIFY AND RENDER',
        date : 'JULY 24, 2023',
        minutes: '5 MINUTE READ',
        preview: "INTRODUCTION: CONGRATS ON FINISHING YOUR FULL-STACK APP! YOU'VE INVESTED TIME, EFFORT, AND CREATIVITY TO BUILD A REMARKABLE APPLICATION, AND NOW . . .",
        link : "https://dev.to/boucky/mastering-the-launch-your-full-stack-app-deployment-guide-with-netlify-and-render-37od",
        image : 'https://blog.tbhcreative.com/wp-content/uploads/website-launch.png'
    },
    {
        id : 8,
        title : 'HOW CHATGPT CAN ASSIST WITH YOUR CODE',
        date : 'AUGUST 3, 2023',
        minutes: '5 MINUTE READ',
        preview: "WHAT IS CHATGPT? IN TODAY'S TECHNOLOGY-DRIVEN LANDSCAPE, CHATGPT HAS BECOME A TERM FAMILIAR TO MANY, EMBODYING THE REMARKABLE . . .",
        link : "https://dev.to/boucky/how-chatgpt-can-assist-with-your-code-1mb3",
        image : 'https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcSIHhCxjBPZlKK-CuOLo7mQL45YbO7Gipj0D5sAvhzRfB0fJ57h'
    },
    {
        id : 9,
        title : 'THE FUTURE OF SOFTWARE DEVELOPMENT: TRENDS TO WATCH IN 2023 AND BEYOND',
        date : 'DECEMBER 8, 2023',
        minutes: '2 MINUTE READ',
        preview: "IN THE EVER-EVOLVING LANDSCAPE OF TECHNOLOGY, SOFTWARE DEVELOPMENT REMAINS AT THE FOREFRONT, CONTINUOUSLY SHAPING HOW WE INTERACT . . .",
        link : "https://dev.to/boucky/the-future-of-software-development-trends-to-watch-in-2023-and-beyond-8jb",
        image : 'https://zegal.com/wp-content/uploads/2021/02/Screen-Shot-2021-02-05-at-9.58.38-AM.png'
    },
    {
        id : 10,
        title : 'JAVA VS. PYTHON: AN INTRODUCTION TO TWO POWERFUL PROGRAMMING LANGUAGES',
        date : 'JANUARY 27, 2024',
        minutes: '5 MINUTE READ',
        preview: "JAVA AND PYTHON ARE TWO OF THE MOST WIDELY USED PROGRAMMING LANGUAGES IN THE WORLD. WHILE PYTHON IS CELEBRATED FOR ITS SIMPLICITY . . .",
        link : "https://dev.to/boucky/introduction-to-java-a-comprehensive-guide-with-python-comparison-5ajo",
        image : 'https://kinsta.com/wp-content/uploads/2023/01/illustration-representing-python-vs-java.png'
    },
    {
        id : 11,
        title : 'WEB APPS VS MOBILE APPS',
        date : 'FEBRUARY 6, 2024',
        minutes: '4 MINUTE READ',
        preview: "IN TODAY'S DIGITAL AGE, THE CHOICE BETWEEN DEVELOPING A WEB APP OR A MOBILE APP CAN BE PIVOTAL FOR BUSINESSES AND DEVELOPERS ALIKE. BOTH OPTIONS OFFER UNIQUE ADVANTAGES AND CATER . . .",
        link : "https://dev.to/boucky/web-apps-vs-mobile-apps-c95",
        image : 'https://www.eventya.net/wp-content/uploads/2021/03/Why-Choose-a-Mobile-App-Over-a-Website.jpg'
    }
]

export default blog